import { createFileRoute } from "@tanstack/react-router";
import { Banknote } from "lucide-react";
import { AdminNav } from "@/components/admin/AdminNav";
import { AdminOnly } from "@/components/admin/AdminOnly";
import { AdminPageHeader } from "@/components/admin/AdminPageHeader";
import { WithdrawalsAdminPanel } from "@/components/admin/WithdrawalsAdminPanel";

export const Route = createFileRoute("/_authenticated/admin/withdrawals")({
  head: () => ({ meta: [{ title: "Withdrawal requests — Admin" }, { name: "robots", content: "noindex" }] }),
  component: () => (
    <AdminOnly>
      <AdminNav />
      <div className="space-y-5">
        <AdminPageHeader
          icon={Banknote}
          title="Withdrawal requests"
          subtitle="Freelancer payout orders awaiting approval and payment"
          tone="text-primary"
          glow="hsl(var(--primary) / 0.30)"
        />
        <WithdrawalsAdminPanel />
      </div>
    </AdminOnly>
  ),
});
